(function () {
	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		const menu = document.querySelector(".list-menu--inline");
		const menuLinks = document.querySelectorAll(".list-menu-item");
		const search = document.querySelector(".header__search");
		const searchInputs = document.querySelectorAll(".search__input[type='search']");
		const mobileSearchTrigger = document.querySelector(".search__button--mobile");
		const mobileSearch = document.querySelector(".search__content--mobile");
		const searchModals = document.querySelectorAll(".search__modal");

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		const annBar = document.querySelector(".section-announcement");
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries;

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					"--ann-height",
					`${entry.boundingClientRect.height}px`,
				);
			} else {
				document.documentElement.style.setProperty("--ann-height", `0px`);
			}
		});
		if (annBar) annBarObserver.observe(annBar);

		menuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (e) => {
				if (link.classList.contains("list-menu--megamenu")) {
					link.classList.add("list-menu--megamenu-visible");
					if (
						header.classList.contains("color-background-3") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.remove("color-background-3");
					}

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove("list-menu--megamenu-visible");
						}
					});
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove("list-menu--megamenu-visible");
					});
				}
			});
		});
		menu.addEventListener("mouseleave", (e) => {
			menuLinks.forEach((link) => {
				link.classList.remove("list-menu--megamenu-visible");
			});
		});

		document.body.addEventListener('mousedown', function() {
			document.body.classList.add('mouse-focus');
		});

		document.body.addEventListener('keydown', function(e) {
				if (e.key === 'Tab') {
					document.body.classList.remove('mouse-focus');
				}
		});

		const waitForElement = (selector, action) => {
			const observer = new MutationObserver((mutationsList, observer) => {
				const element = document.querySelector(selector);
				if (element) {
					observer.disconnect(); // Зупиняємо спостереження
					if(action == 'hide'){
						element.classList.remove("snize-ac-results--visible");
					}else{
						element.classList.add("snize-ac-results--visible");
					}
				}
			});

			// Спостерігаємо за змінами у всьому DOM
			observer.observe(document.body, { childList: true, subtree: true });
		}

		const serchaniceAction = (action) => {
			let serchanice = document.querySelector('.snize-ac-results');
			
			if(serchanice){
				if(action == 'hide'){
					serchanice.classList.remove("snize-ac-results--visible");
				}else{
					serchanice.classList.add("snize-ac-results--visible");
				}
				return;
			}

			waitForElement('.snize-ac-results', action);
		}

		const hideWidgetsWhenSearch = (action) => {
			if(action == 'hide'){
				document.querySelector('#smile-ui-container') && (document.querySelector('#smile-ui-container').classList.add('widget-hidden'));  /* hide reward points app btn */
				document.querySelector('#dummy-chat-button-iframe') && (document.querySelector('#dummy-chat-button-iframe').classList.add('widget-hidden'));  /* hide chart app btn */
				document.querySelector('.kl-teaser-VV9SWy') && (document.querySelector('.kl-teaser-VV9SWy').classList.add('widget-hidden'));
				document.querySelector('#shopify-chat inbox-online-store-chat') && (document.querySelector('#shopify-chat inbox-online-store-chat').classList.add('widget-hidden'));
				document.querySelector('#giftbox-root iframe') && (document.querySelector('#giftbox-root iframe').classList.add('widget-hidden'));
				document.querySelector('access-widget-ui') && (
					document.querySelectorAll('access-widget-ui').forEach((el) => el.classList.add('widget-hidden'))
				);
				if (matchMedia('(max-width: 700px)').matches) { document.querySelector('.bacurr-choiceDesign') && (document.querySelector('.bacurr-choiceDesign').classList.add('widget-hidden')); }
			}else{
				document.querySelector('#smile-ui-container') && (document.querySelector('#smile-ui-container').classList.remove('widget-hidden')); /* show reward points app btn */
				document.querySelector('#dummy-chat-button-iframe') && (document.querySelector('#dummy-chat-button-iframe').classList.remove('widget-hidden'));  /* hide chart app btn */
				document.querySelector('.kl-teaser-VV9SWy') && (document.querySelector('.kl-teaser-VV9SWy').classList.remove('widget-hidden'));
				document.querySelector('#shopify-chat inbox-online-store-chat') && (document.querySelector('#shopify-chat inbox-online-store-chat').classList.remove('widget-hidden'));
				document.querySelector('#giftbox-root iframe') && (document.querySelector('#giftbox-root iframe').classList.remove('widget-hidden'));
				document.querySelector('access-widget-ui') && (
					document.querySelectorAll('access-widget-ui').forEach((el) => el.classList.remove('widget-hidden'))
				);
				if (matchMedia('(max-width: 700px)').matches) { document.querySelector('.bacurr-choiceDesign') && (document.querySelector('.bacurr-choiceDesign').classList.remove('widget-hidden')); }
			}
		}

		const searchActions = () => {
			searchInputs.forEach((input) => {
				input.addEventListener("focus", (e) => {
					if(e.currentTarget.classList.contains('search__input--mobile')){
						hideWidgetsWhenSearch('hide');
					}
					if(searchModals.length > 0){
						searchModals.forEach((modal) => {
							modal.classList.remove("search__modal--hidden");
						});
					}

					document.body.classList.add("overflow-hidden");
					serchaniceAction('hide');
				});

				input.addEventListener('focusout', (e) => {
					if (e.relatedTarget && e.relatedTarget.closest('.search__modal') || e.currentTarget.classList.contains('search__input--mobile') || e.relatedTarget && e.relatedTarget.closest('.snize-ac-results')) {
						return;
					}

					if(searchModals.length > 0){
						searchModals.forEach((modal) => {
							modal.classList.add("search__modal--hidden");
						});
					}

					input.value = "";
					serchaniceAction('hide');
					document.body.classList.remove("overflow-hidden");
				});

				input.addEventListener('input', (e) => {
					if (e.target.value.length > 0) {
						serchaniceAction('show');

						if(searchModals.length > 0){
							searchModals.forEach((modal) => {
								modal.classList.add("search__modal--hidden");
							});
						}
					} else {
						if(searchModals.length > 0){
							searchModals.forEach((modal) => {
								modal.classList.remove("search__modal--hidden");
							});
						}

						serchaniceAction('hide');
					}
				});

				if(searchModals.length > 0){
					input.addEventListener("keydown", (e) => {
						if (e.code === "Escape") {
							input.value = "";
							searchModals.forEach((modal) => {
								modal.classList.add("search__modal--hidden");
							});
						}
					});
				}
			});

			if(mobileSearchTrigger && mobileSearch){
				mobileSearchTrigger.addEventListener("click", () => {
					mobileSearch.classList.toggle("open");
					mobileSearch.querySelector('input[type="search"]').value = "";
					serchaniceAction('hide');

					if(searchModals.length > 0){
						searchModals.forEach((modal) => {
							modal.classList.add("search__modal--hidden");
						});
					}

					if(document.body.classList.contains("overflow-hidden")) document.body.classList.remove("overflow-hidden");
					if(!mobileSearch.classList.contains("open")){
						hideWidgetsWhenSearch('show');
					};
				});
				document.documentElement.style.setProperty(
					"--mobile-search-height",
					`${mobileSearch.offsetHeight}px`,
				);
			} 

			header.addEventListener("keydown", (e) => {
				if (e.code === "Escape" && search.isOpen) {
					search.close();
				}
			});
		}

		if(searchInputs.length > 0){
			searchActions();
		}

		const addBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains("color-background-3") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.remove("color-background-3");
					}
				}
			});

			headerObserver.observe(header);
		};

		const removeBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains("color-background-1") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.add("color-background-3");
					}
				}
			});

			headerObserver.observe(header);
		};

		header.addEventListener("mouseenter", addBackground);

		header.addEventListener("focus", addBackground);

		header.addEventListener("focusin", addBackground);

		header.addEventListener("mouseleave", removeBackground);

		header.addEventListener("focusout", removeBackground);

		const megaMenuListLinks = () => {
			const megaMenuLinkWithSubmenu = document.querySelector(
				".mega-menu__list-item--children",
			);
			const megaMenuLinks = document.querySelectorAll(".mega-menu__list-item");
			if (megaMenuLinkWithSubmenu) {
				megaMenuLinks.forEach((link) => {
					link.classList.add("mega-menu__list-item--opacity");
				});
				megaMenuLinkWithSubmenu.classList.remove(
					"mega-menu__list-item--opacity",
				);
				megaMenuLinkWithSubmenu.classList.add("mega-menu__list-item--visible");
			}
			$(".mega-menu__list-item").mouseenter(function (event) {
				if (megaMenuLinkWithSubmenu) {
					megaMenuLinkWithSubmenu.classList.remove(
						"mega-menu__list-item--visible",
					);
				}
				$(this).removeClass("mega-menu__list-item--opacity");
				$(this).siblings().addClass("mega-menu__list-item--opacity");
				$(this).mouseleave(() => {
					$(this).siblings().removeClass("mega-menu__list-item--opacity");
				});
			});
			$(".mega-menu__list-item").focus(function (event) {
				if (megaMenuLinkWithSubmenu) {
					megaMenuLinkWithSubmenu.classList.remove(
						"mega-menu__list-item--visible",
					);
				}
				$(this).removeClass("mega-menu__list-item--opacity");
				$(this).siblings().addClass("mega-menu__list-item--opacity");
				$(this).mouseleave(() => {
					$(this).siblings().removeClass("mega-menu__list-item--opacity");
				});
			});
		};

		const megaMenuSublinks = () => {
			$(".mega-menu--list .mega-menu__submenu-item").mouseenter(function (
				event,
			) {
				$(this).removeClass("mega-menu__submenu-item--opacity");
				$(this)
					.parent()
					.siblings()
					.find(".mega-menu__submenu-item")
					.addClass("mega-menu__submenu-item--opacity");
				$(this).mouseleave(() => {
					$(this)
						.parent()
						.siblings()
						.find(".mega-menu__submenu-item")
						.removeClass("mega-menu__submenu-item--opacity");
				});
			});
			$(".mega-menu--list .mega-menu__submenu-item").focusin(function (event) {
				$(this).removeClass("mega-menu__submenu-item--opacity");
				$(this)
					.parent()
					.siblings()
					.find(".mega-menu__submenu-item")
					.addClass("mega-menu__submenu-item--opacity");
				$(this).focusout(() => {
					$(this)
						.parent()
						.siblings()
						.find(".mega-menu__submenu-item")
						.removeClass("mega-menu__submenu-item--opacity");
				});
			});
		};
		megaMenuListLinks();
		megaMenuSublinks();

		const main = document.querySelector("main");
		const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
		if (
			main
				.querySelectorAll(".shopify-section")[0]?.classList.contains("section--has-overlay") &&
			!main
				.querySelectorAll(".shopify-section")[0]?.classList.contains("not-margin")
		) {
			header.classList.add("color-background-1", "color-background-3");
			if (breadcrumbs) {
				breadcrumbs.classList.add("color-background-3");
			}
		}

		// Allow for filtering of Designers in meganav
		const queryInputs = document.querySelectorAll('.designer-query-input');
		const queryInputMobiles = document.querySelectorAll('.designer-query-input__mobile');

		const designerFilter = (e) => {
			var value = e.target.value;
			var subDesignerLinkSpans = [];
			var subDesignerLinks = e.target.closest('ul').getElementsByTagName('li');

			if (subDesignerLinks) {
				subDesignerLinkSpans = Array.prototype.map.call(subDesignerLinks, function(link) {
					if (link.querySelector('a span')) {
						return link.querySelector('a span').innerHTML.trim();
					} else {
						return link.querySelector('a').innerHTML.trim();
					}
				});
			}

			if (subDesignerLinks) {
				var re = new RegExp('\\b' + value + '.*', 'i');
				subDesignerLinkSpans.forEach(function(span, i) {
					if (span.match(re)) {
						subDesignerLinks[i].classList.remove('hidden');
					} else {
						subDesignerLinks[i].classList.add('hidden');
					}
				});
			}
		};

		queryInputs.forEach((input) => {
			input.addEventListener('input', designerFilter);
		});
		queryInputMobiles.forEach((inputMobile) => {
			inputMobile.addEventListener('input', designerFilter);
		});
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();
